import { classNames } from '../../utils';
import { FormInputCommonProps } from './types';
import { ReactComponent as CheckIcon } from '../icons/check.svg';
import * as RadioGroup from '@radix-ui/react-radio-group';
import { twMerge } from 'tailwind-merge';

interface RadioGroupInputProps extends FormInputCommonProps {
  checked?: boolean;
  readOnly?: boolean;
  onChange?: (value: any) => void;
  label?: string;
  id?: string;
  value: string;
}

export const RadioGroupInput: React.FC<RadioGroupInputProps> = ({
  className = '',
  checked,
  disabled,
  onChange,
  id,
  label,
  readOnly,
  value,
}) => {
  return (
    <>
      <RadioGroup.Root className="flex flex-col gap-[10px] mr-2">
        <RadioGroup.Item
          className="bg-white w-[16px] h-[16px] rounded-full border-2 border-sunroom-900"
          value={value}
          checked={checked}
          //@ts-ignore
          onChange={(e) => {
            if (onChange) {
              onChange(e);
            }
          }}
          id={id}
          disabled={disabled}
        >
          <RadioGroup.Indicator className="flex items-center justify-center w-full h-full relative  after:content-[' '] after:block after:w-[8px] after:h-[8px] after:rounded-[50%] after:bg-sunroom-900" />
        </RadioGroup.Item>
        {label ? (
          <label
            htmlFor={id}
            className={twMerge(
              'typo-body-small typo-base block font-sans text-[0.875rem] leading-[1.225rem] tracking-[0.015625rem] text-sidewalk-900 '
            )}
          >
            {label}
          </label>
        ) : null}
      </RadioGroup.Root>
    </>
  );
};
